import React from "react";
import PropTypes from "prop-types";
import AttachmentsContainer from "./attachments/components/AttachmentsContainer";
import PrintsContainer from "./prints/components/PrintsContainer";

const DocumentsContainer = ({ documentId }) => {
  return (
    <>
      <PrintsContainer documentId={documentId} />
      <AttachmentsContainer documentId={documentId} />
    </>
  );
};

DocumentsContainer.propTypes = {
  documentId: PropTypes.number.isRequired
};
export default DocumentsContainer;
